import { gql } from '@apollo/client';

export const SAVE_INSERT_BLOCKS = gql`
  mutation SaveInsertblock($saveInsertblockInput: SaveInsertblockInput!) {
    saveInsertblock(saveInsertblockInput: $saveInsertblockInput) {
      insertblocks {
        id
        tag
        grooveDiaMetric
        grooveDiaEnglish
        updatedBy
        updatedTime
      }
      errors {
        messageKeys
        tag
      }
      infos {
        messageKeys
        tag
      }
      deletedIds
    }
  }
`;
